import _ from 'lodash';
import {fields} from './fields.js';

const ginekoloskaPosjeta = {
    main: [
        {
            wrapper: 'row',
            className: 'row',
            fieldGroup: [
                _.merge({className: 'col-md-6', templateOptions: {disabled: true}}, fields.djelatnost),
                _.merge({className: 'col-md-6'}, fields.doktor)
            ]
        },
        {
            wrapper: 'fieldset',
            className: 'col-md-8',
            templateOptions: {
                label: 'Dijagnoza'
            },
            fieldGroup: [
                fields.dijagnoza,
                fields.dijagnoza_text
            ]
        },
        {
            wrapper: 'fieldset',
            className: 'col-md-8',
            fieldGroup: [
                fields.datum,
                _.merge({templateOptions: {disabled: true}}, fields.vrstaPosjete),
            ]
        },
    ],
    tabs : [
        {
            title: 'Anamesis',
            fields: [
                fields.anamesis_fam,
                fields.anamesis_vitae,
                fields.anamesis_gyn,
            ]
        },
        {
            title: 'Tab 2',
            active: true,
            fields: [
                fields.ostalo,
                fields.zm,
                fields.prethodna_gin_operacija_prije,
                fields.sadasnje_tegobe,
            ]
        },
        {
            title: 'Tab 3',
            fields: [
                fields.klinicki_pregled,
                fields.dodatne_pretrage,
                fields.komentari_preporuka,
            ]
        },
        {
            title: 'Tab 4',
            fields: [
                fields.hormonski_pripravci_iucd,
                fields.ginekoloske_operacije,
                fields.papa,
                fields.uz_vs_cd,
                fields.napomena_gyn
            ]
        },
        {
            title: 'Postojeći unosi',
            fields: [
                {
                    key: 'pregledi',
                    type: 'feed',
                }
            ]
        }

    ]
};


export {ginekoloskaPosjeta};



// WEBPACK FOOTER //
// ./app/components/pregled/form/ginekoloskaPosjeta.js